export default __webpack_public_path__ + "static/media/shareicon.4d382ecc.svg";